import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import objectId from 'bson-objectid';
import {
  Container,
  Button as FloatActionButton
} from 'react-floating-action-button';
import { useSelector, useDispatch } from 'react-redux';
import { store as storeNotification } from 'react-notifications-component';

import { editDashboards } from '../../redux/actions/dashboards';
import AlertMsg from '../../components/AlertMsg';
import tableCalls from '../../config-panel-dash/tableCalls';
import tableGroups from '../../config-panel-dash/tableGroups';
import tableNetworksGroup from '../../config-panel-dash/tableNetworksGroup';
import tableUsers from '../../config-panel-dash/tableUsers';

const ModalAddPanel = props => {
  const notificationConfig = {
    container: 'top-center',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    inset: 'top',
    dismiss: {
      duration: 2000,
      showIcon: false
    }
  };
  const INITIAL_VALUE = { type: '', name: '' };
  const [modalShow, setModalShow] = useState(false);
  const [newPanel, setNewPanel] = useState({ ...INITIAL_VALUE });
  const dispatch = useDispatch();
  const authentications = useSelector(state => state.authentications);
  const dashboards = useSelector(state => state.dashboards);
  const dash = dashboards.data.find(dash => dash.selected);
  const typesPanel = {
    TU: tableUsers,
    TG: tableGroups,
    TON: tableNetworksGroup,
    TC: tableCalls
  };

  const showModalAddPanel = () => {
    if (dashboards.enableTransition) {
      storeNotification.addNotification({
        ...notificationConfig,
        title: 'Desabilite a transição para adicionar o painel',
        message: ' ',
        type: 'danger'
      });
    } else {
      setModalShow(true);
    }
  };

  const handleChangeModal = evt => {
    evt.preventDefault();
    const { value, options, name } = evt.target;
    if (name === 'type') {
      if (!value) {
        setNewPanel({ ...INITIAL_VALUE });
      } else {
        for (const op of options) {
          if (op.value === value) {
            setNewPanel({
              ...newPanel,
              type: value
            });
          }
        }
      }
    } else {
      setNewPanel({
        ...newPanel,
        name: value
      });
    }
  };

  const handleClickAddPanel = () => {
    const item = {
      i: objectId().str,
      ...newPanel,
      fontHeader: typesPanel[newPanel.type] ? '16' : undefined,
      fontContent: typesPanel[newPanel.type] ? '16' : undefined,
      fields: typesPanel[newPanel.type] ? typesPanel[newPanel.type] : undefined,
      configFields:
        typesPanel[newPanel.type] || newPanel.type === 'GQ' ? [] : undefined,
      fontSizeInitials: newPanel.type === 'GQ' ? '50' : undefined,
      fontSizeName: newPanel.type === 'GQ' ? '50' : undefined,
      fontSizeNumber: newPanel.type === 'GQ' ? '50' : undefined,
      fontSizeQueue: newPanel.type === 'GQ' ? '50' : undefined,
      showInitials: newPanel.type === 'GQ' ? true : undefined,
      showName: newPanel.type === 'GQ' ? false : undefined,
      showNumber: newPanel.type === 'GQ' ? true : undefined,
      members: [],
      typeDisplay: 'ALL',
      x: 0,
      y: Number.MAX_SAFE_INTEGER,
      w: 30,
      h: 30,
      minW: 10,
      minH: 10,
      maxW: Number.MAX_SAFE_INTEGER,
      maxH: Number.MAX_SAFE_INTEGER,
      static: false,
      isDraggable: true,
      isResizable: true
    };
    const updateDash = {
      _id: dash ? dash._id : objectId().str,
      user: dash ? dash.user : authentications.user._id,
      name: dash ? dash.name : 'Default',
      transition: true,
      selected: true,
      theme: dash ? dash.theme : 'default-theme',
      items: dash ? dash.items.concat(item) : [item]
    };
    dispatch(editDashboards(updateDash));
  };

  return (
    <React.Fragment>
      <Modal
        {...props}
        show={modalShow}
        onExited={() => setNewPanel({ ...INITIAL_VALUE })}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          {dashboards.editSuccess && (
            <AlertMsg type="success" msg="Painel adicionado com sucesso" />
          )}
          {dashboards.editError && (
            <AlertMsg type="danger" msg="Falha durante adição do painel" />
          )}
          {!dashboards.editSuccess && !dashboards.editError && (
            <AlertMsg type="info" msg="Área adicionar painel no dashboard" />
          )}
          <div>
            <h3>Adicionar Painel </h3>
            <Form.Group>
              <Form.Label>Tipo</Form.Label>
              <Form.Control
                as="select"
                name="type"
                value={newPanel.type}
                onChange={handleChangeModal}
              >
                <option value="">-- Selecione --</option>
                <option value="TU">Tabela Usuários</option>
                <option value="TG">Tabela Grupos</option>
                <option value="TC">Tabela Ligações</option>
                <option value="TON">Tabela Ocupação de Troncos</option>
                <option value="GQ">Gráfico Fila</option>
                <option value="GON">Gráfico Ocupação de Troncos</option>
                <option value="GG">Gráfico Produtividade de Grupos</option>
                <option value="GGH">
                  Gráfico Produtividade de Grupos por Hora
                </option>
                <option value="GGHP">
                  Gráfico Produtividade de Grupos por Hora Percentual
                </option>
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Nomear</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ex: Atendimento"
                value={newPanel.name}
                name="name"
                autoComplete="off"
                onChange={handleChangeModal}
                disabled={!newPanel.type}
              />
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalShow(false)}>
            <span>
              <i className="fas fa-times" /> Fechar
            </span>
          </Button>
          <Button
            variant="primary"
            onClick={handleClickAddPanel}
            disabled={
              dashboards.isFetching || !(newPanel.name && newPanel.type)
            }
          >
            <span>
              <i className="fas fa-plus" /> Adicionar
            </span>
          </Button>
        </Modal.Footer>
      </Modal>
      <Container className="cont-btn-add">
        <FloatActionButton
          onClick={() => showModalAddPanel()}
          className="btn-add"
          tooltip="Novo Painel"
          icon="fa fa-plus fa-2x"
        />
      </Container>
    </React.Fragment>
  );
};

export default ModalAddPanel;
